import React from 'react'
import './Hobby.css'

const Hobby = () => {
    return ( 
        <div className='hobby-container'>
            <h1>Hobbies</h1>
            <div className="chess">Chess</div>
            <div className="coding">Coding</div>
            <div className="badminton">Badminton</div>
            <img src='/hobby/chess.jpg' alt='' id='chess'/>
            <img src='/hobby/coding.jpg' alt='' id='coding'/>
            <img src='/hobby/badminton.jpg' alt='' id='badminton' />
        </div>
    )
}

export default Hobby
